import BaseClient from './client';

export const BmiPath = Object.freeze({
  MEASUREMENT: 'doctor/bmi',
});

const appointmentKey = (appointmentId) => {
  if (appointmentId === undefined || appointmentId === null || appointmentId === '') {
    throw new TypeError('appointmentId is required');
  }
  return appointmentId;
};

/**
 * Body mass index recorded per appointment. The backend computes the BMI and its
 * category and scopes every call to the authenticated doctor's own appointments.
 */
export class BmiService extends BaseClient {
  /** Returns `{ appointmentId, current, history }`. */
  async fetchMeasurements(appointmentId, { limit, ...options } = {}) {
    const response = await this.get(BmiPath.MEASUREMENT, {
      ...options,
      params: { appointment_id: appointmentKey(appointmentId), ...(limit ? { limit } : {}) },
    });
    return response.unwrap().data;
  }

  /** `values`: `{ sex, age, heightCm, weightKg }`. */
  async saveMeasurement(appointmentId, { sex, age, heightCm, weightKg }) {
    const response = await this.put(BmiPath.MEASUREMENT, {
      appointment_id: appointmentKey(appointmentId),
      sex: sex || null,
      age: age === '' || age === null || age === undefined ? null : Number(age),
      height_cm: Number(heightCm),
      weight_kg: Number(weightKg),
    });
    return response.unwrap().data;
  }
}

export const createBmiService = (baseUrl, options) => new BmiService(baseUrl, options);

export const bmiService = new BmiService();

export default BmiService;
